'use client';

import Script from 'next/script';
import { useEffect } from 'react';

/**
 * Renders a script tag with a polyfill for the globalThis object.
 * https://github.com/vercel/next.js/discussions/58818#discussioncomment-8431496
 */
const GlobalThisPolyfill = () => {
  useEffect(() => {
    // Add any immediate polyfill logic here if needed
    if (typeof globalThis === 'undefined') {
      (global as any).globalThis = global;
    }
  }, []);

  return (
  <Script
    id="globalthis-polyfill"
    strategy="afterInteractive"
    dangerouslySetInnerHTML={{
      __html: `!function(t){function e(){var e=this||self;e.globalThis=e,delete t.prototype._T_}"object"!=typeof globalThis&&(this?e():(t.defineProperty(t.prototype,"_T_",{configurable:!0,get:e}),_T_))}(Object);`,
    }}
  />

  )
};

export default GlobalThisPolyfill;
